// extracted by mini-css-extract-plugin
module.exports = {"lia-separator":"MultiAuthLoginForm_lia-separator__5MgKS"};